import { render, staticRenderFns } from "./baoxiao.vue?vue&type=template&id=29cb9c6a&"
import script from "./baoxiao.vue?vue&type=script&lang=js&"
export * from "./baoxiao.vue?vue&type=script&lang=js&"
import style0 from "./baoxiao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports